import {  Button, Table, message } from "antd";
import { useEffect, useState } from "react";
import {  cancelTask, getTasks } from "~@/API/fake";
import {  TaskType } from "~@/types/fake";
import { PageResponseType } from "~@/types/universal";
import { showTotal } from "~@/utils/helper";

const TaskList = ()=>{
  const [data,setData] = useState<PageResponseType<TaskType>>();
  const columns = [
    {
      title: "任务类型",
      dataIndex: "type",
    },
    {
      title: "任务状态",
      dataIndex: "status",
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
    },
    {
      title: "操作",
      dataIndex: "action",
      render:(_:undefined,record:TaskType)=>{
        return <Button type="link" disabled={record?.status==="已完成"} onClick={async()=>{
           const res = await cancelTask({id: record.id})
           setData((state)=>{
            if (!state) return undefined
            return {
                ...state,
                records: state.records.filter(item=>item.id!==record.id)
            }
           })
           message.success(res.originResponse.message)
        }}>取消</Button>
      }
    },
  ];

  useEffect(()=>{
    getTasks({currentPage: 1, pageSize: 10}).then((res)=>{
      if (res?.success){
        setData(res.data)
      }
    })
  },[])
  return (
    <>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data?.records || []}
        pagination={{ showTotal, size: "small", showSizeChanger: true }}
      />
    </>
  );
}

export default TaskList